import { Pipe, PipeTransform } from '@angular/core';

import { IEnclosure } from '../../shared/models/enclosure.model';

@Pipe({
    name: 'pmcContainsEmptySpaces',
    standalone: false
})
export class PmcContainsEmptySpacesPipe implements PipeTransform {

  transform(selectedEnclosure: IEnclosure, widthOfAllProducts: number): boolean {
    if (!selectedEnclosure?.fields) {
      return false;
    }
    return widthOfAllProducts !== selectedEnclosure?.fields;
  }

}
